import { Survey } from '../../survey.class';
import { getPropertyDescriptor } from '../../../../functions';

const type = 'afterschool';

declare module '../../survey.class' {
  interface Survey {
    afterschool_possible_tags:string[];
  }
}

let SurveyValue = getPropertyDescriptor(Survey.prototype, 'value');
let SurveySupportedQuestionTypes = getPropertyDescriptor(Survey.prototype, 'supportedQuestionTypes');
Object.defineProperties(Survey.prototype, {
  value:{
    get: function(): boolean {
      if (this.type === type) {
        return {
          ...SurveyValue.get.apply(this),
          afterschool_possible_tags: this.afterschool_possible_tags,
        };
      } else {
        return SurveyValue.get.apply(this);
      }
    }    
  },  
  supportedQuestionTypes:{
    get: function(): boolean {
      if (this.type === type) {
        return SurveySupportedQuestionTypes.get.apply(this).concat(['afterschool']);
      } else {
        // return SurveySupportedQuestionTypes.get.apply(this);
        return SurveySupportedQuestionTypes.get.apply(this).concat(['afterschool']);
      }
    }    
  },
  afterschool_possible_tags:{
    get: function():string[] {
      return this.get('afterschool_possible_tags') || [];
    },
    set: function(v:string[]) {
      this.set('afterschool_possible_tags', v);
    },   
  },
})
console.log("survey type afterschool is added");